import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js"
import { COLOR, formatVnd, formatVndCompact } from "procurement/design"

ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
)

export const SERIES = {
  budget: COLOR.neutral600,
  committed: COLOR.warning600,
  unpaid: COLOR.info600,
  paid: COLOR.success600,
  used: COLOR.brand500,
  danger: COLOR.danger600,
}

export const moneyTick = (value) => formatVndCompact(value)
export const pctTick = (value) => `${value}%`
export const moneyTooltip = (ctx) => `${ctx.dataset.label}: ${formatVnd(ctx.raw)}`

export const baseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: "index", intersect: false },
  plugins: {
    legend: { position: "bottom", labels: { boxWidth: 12, boxHeight: 12, color: COLOR.textSecondary } },
    tooltip: { callbacks: { label: moneyTooltip } },
  },
}

export const gridColor = COLOR.border
export const tickColor = COLOR.textSecondary

export const pctOf = (n) => (n == null ? "—" : `${Number(n).toFixed(2)}%`)
